<app-field-container [field]="this">
  <div class="uploader-container">
    <div class="position-relative">
      @if (control.value?.id) {
        <app-cover-viewer
          [url]="url()"
          [thumbnailUrl]="thumbnailUrl()">
        </app-cover-viewer>
        <button type="button" class="btn btn-light" style="position: absolute; left: 10px; bottom: 10px;" (click)="delete()">
          {{ deleteLabel() }}
        </button>
      }
      @else {
        <div class="row justify-content-center align-items-center h-100">
          <div class="col-auto text-center py-5">
            <input
              type="file"
              style="display: none"
              [accept]="acceptMimeTypes"
              (change)="onFileSelected($event)"
              (cancel)="onCancelSelect($event)"
              #fileUpload/>
            <button type="button" class="btn btn-outline btn-outline-primary" (click)="fileUpload.click()">
              {{ uploadLabel() }}
              <lucide-icon [img]="icons.Image"></lucide-icon>
            </button>
            <p class="text-center">
              Images {{ supportedFormats.join(', ') }} supportées.<br/>
              Dimensions recommandées {{ MAX_WIDTH }}px min.
            </p>
          </div>
        </div>
      }
    </div>
  </div>

  @if (previewUrl) {
    <div class="preview-container text-center">
      <div class="container">
        <div class="row align-items-center justify-content-center mt-5">
          <div class="col-12 controls">
            <button class="btn btn-sm btn-light mx-2" (click)="reset()">
              <lucide-icon [img]="icons.Cancel"></lucide-icon>
            </button>
            <button class="btn btn-sm btn-light mx-2" (click)="rotate('left')">
              <lucide-icon [img]="icons.Left"></lucide-icon>
            </button>
            <button class="btn btn-sm btn-light mx-2" (click)="rotate('right')">
              <lucide-icon [img]="icons.Right"></lucide-icon>
            </button>
            <button class="btn btn-success mx-2" (click)="uploadFile()">
              <lucide-icon [img]="icons.Upload"></lucide-icon>
              Ok
            </button>
          </div>
        </div>
        <div class="preview-img-container my-2">
          <img [src]="previewUrl" alt="Image Preview"/>
        </div>
      </div>
    </div>
  }
</app-field-container>
